import {ILink} from "@/types/models/ILink.ts";
import {LinkAction, linkActionToColor} from "@/types/enums/LinkAction.ts";
import {useForm} from "@mantine/form";
import OmniFetchTS from "@/util/OmniFetchTS.tsx";
import {modals} from "@mantine/modals";
import {Button, Group, Stack, Text, TextInput} from "@mantine/core";
import {LINK_MODAL_ID} from "@/components/SidebarLinks/LinkModal/modal_utils.tsx";

export interface LinkModalProps {
    link: ILink | null
    action: LinkAction
    onComplete: () => void
}

export default function LinkModal({link, action, onComplete}: LinkModalProps) {
    interface LinkForm {
        id: string
        category: string | undefined
        name: string
        href: string
    }
    const form = useForm<LinkForm>({
        initialValues: {
            id: link ? link.id.toString() : "",
            category: link ? link.category : "",
            name: link ? link.name : "",
            href: link ? link.href : "",
        },
        validate: {
            category: (v) => {
                if (v == undefined) return "The Category name must be provided"
                return v.length <= 72 ? null : "The Category name must be less than 72 characters"
            },
            name: (v) => v.length <= 72 ? null : "The Link name must be less than 72 characters",
            href: (v) => v.length <= 2000 ? null : "The Link URL must be less than 2000 characters",
        }
    })
    return <form onSubmit={form.onSubmit((values) => {
        let submitPath = "/api/v1/links"
        if (values.id != null) {
            submitPath += `/${values.id}`
        }
        if (action != LinkAction.DELETE) {
            OmniFetchTS(submitPath, {method: "POST"}, {
                "category": values.category,
                "name": values.name,
                "href": values.href
            }).then((json) => {
                if (json.success) {
                    onComplete()
                    modals.close(LINK_MODAL_ID)
                }
            })
        } else {
            OmniFetchTS(submitPath, {method: "DELETE"}).then((json) => {
                if (json.success) {
                    onComplete()
                    modals.close(LINK_MODAL_ID)
                }
            })
        }
    })}>
        <Stack>
            {action !== LinkAction.DELETE && <Stack>
                <TextInput
                    label={"Category"} required
                    description={"The name of the Category this Link should be listed under"}
                    {...form.getInputProps("category")}
                />
                <TextInput
                    label={"Name"} required
                    description={"The name of this Link"}
                    {...form.getInputProps("name")}
                />
                <TextInput
                    label={"URL"} required
                    description={"The location this Link should direct users to, start with / to navigate to an Omni page"}
                    {...form.getInputProps("href")}
                />
            </Stack>}
            <Text style={{wordBreak: "break-all"}} hidden={action !== LinkAction.DELETE}>The link &quot;{link != null ? link["category"]+"/"+link["name"] : ""}&quot; will be deleted. Continue?</Text>
            <Group justify={"end"}>
                <Button variant="default" onClick={() => modals.close(LINK_MODAL_ID)}>Cancel</Button>
                <Button color={linkActionToColor(action)} type={"submit"}>{action} Link</Button>
            </Group>
        </Stack>
    </form>
}